function getToggleElements() {
    const menuButton = document.getElementById('menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    if (!menuButton || !mobileMenu)
        return null;
    return { menuButton, mobileMenu };
}
function openMenu({ menuButton, mobileMenu }) {
    menuButton.setAttribute('aria-expanded', 'true');
    mobileMenu.classList.remove('hidden');
    // animate open
    mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
}
function closeMenu({ menuButton, mobileMenu }) {
    menuButton.setAttribute('aria-expanded', 'false');
    // animate close
    mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
    // force reflow to apply current height before transition
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    mobileMenu.offsetHeight;
    mobileMenu.style.maxHeight = '0px';
    // after transition, hide completely
    const onTransitionEnd = () => {
        if (menuButton.getAttribute('aria-expanded') === 'false') {
            mobileMenu.classList.add('hidden');
        }
        mobileMenu.removeEventListener('transitionend', onTransitionEnd);
    };
    mobileMenu.addEventListener('transitionend', onTransitionEnd);
}
function toggleMenu(elements) {
    const expanded = elements.menuButton.getAttribute('aria-expanded') === 'true';
    if (expanded) {
        closeMenu(elements);
    }
    else {
        openMenu(elements);
    }
}
export function initializeHeader() {
    const elements = getToggleElements();
    if (!elements)
        return;
    const { menuButton, mobileMenu } = elements;
    // Start closed
    menuButton.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.add('hidden');
    mobileMenu.style.maxHeight = '0px';
    menuButton.addEventListener('click', () => toggleMenu(elements));
    // Close when clicking a link
    mobileMenu.addEventListener('click', (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === 'a') {
            closeMenu(elements);
        }
    });
    // Close on Escape
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeMenu(elements);
        }
    });
    // Close if resizing to desktop breakpoint
    const media = window.matchMedia('(min-width: 768px)');
    media.addEventListener('change', () => {
        if (media.matches) {
            menuButton.setAttribute('aria-expanded', 'false');
            mobileMenu.classList.add('hidden');
            mobileMenu.style.maxHeight = '';
        }
    });
}
